import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPromoEnclosed = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 10,
		cy: 10,
		r: 10,
		fill: "#ffb100"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "#2b3236",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m10.588 5.358 1.282 2.77h2.495a.613.613 0 0 1 .43 1.07l-2.162 2.134 1.2 2.762a.656.656 0 0 1-.93.819l-2.9-1.636L7.1 14.913a.654.654 0 0 1-.93-.82l1.2-2.76-2.162-2.135a.614.614 0 0 1 .425-1.07h2.495l1.28-2.77a.664.664 0 0 1 1.18 0"
	})]
});
export { SvgIconPromoEnclosed as ReactComponent };
